import React, { useEffect, useState } from "react"

import { GoogleApiWrapper } from "google-maps-react"

import {
  SuggestModalContent,
  SuggestModalSubHeader,
  SuggestModalLeftSide,
} from "../../components"

import FooterButtons from "./FooterButtons"
import MapContainer from "./MapContainer"
import Pinboard from "./Pinboard"
import SearchField from "./SearchField"

import "./index.scss"
import useInPersonTabState from "../Hooks/useInPersonTabState"

const InPersonTab = ({
  close,
  onSave,
  handleClose,
  teeupId,
  forCreateTeeup,
}) => {
  const { activePlace, setMapCenter, setActivePlace } = useInPersonTabState()

  const [userLocation, setUserLocation] = useState(null)

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        setUserLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
      })
    }

    return () => {
      setMapCenter({
        lat: 49.282_729_1,
        lng: -123.120_737_5,
      })
      setActivePlace(null)
    }
  }, [])

  return (
    <div className="suggest-in-person">
      <SuggestModalLeftSide>
        <SuggestModalSubHeader>
          <Pinboard activePlace={activePlace} />
        </SuggestModalSubHeader>
        <SuggestModalContent>
          {userLocation && <SearchField userLocation={userLocation} />}
        </SuggestModalContent>

        {activePlace && (
          <FooterButtons
            handleClose={forCreateTeeup ? close : handleClose}
            teeupId={teeupId}
            onSave={onSave}
          />
        )}
      </SuggestModalLeftSide>
      <MapContainer />
    </div>
  )
}

// BUG-003 (2026-07-10): only wrap in the Maps JS loader when a key is present. With the key
// stripped, render InPersonTab directly so it never hangs on the SDK loader; the map tile guards
// itself (see MapContainer) and place search runs through the backend proxy.
export default process.env.REACT_APP_GOOGLE_MAPS_JS_KEY
  ? GoogleApiWrapper({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_JS_KEY,
    })(InPersonTab)
  : InPersonTab
